// Utility for rendering frontend templates with variable substitution
// Supports {{variableName}} syntax for variable replacement

export function renderTemplate(templateContent, variables = {}) {
  if (!templateContent) return "";

  let rendered = templateContent;

  // Replace all {{variableName}} with actual values
  Object.keys(variables).forEach((key) => {
    const regex = new RegExp(`\\{\\{${key}\\}\\}`, "g");
    const value = variables[key] || "";
    rendered = rendered.replace(regex, value);
  });

  // Remove any remaining unmatched variables (optional - can be customized)
  rendered = rendered.replace(/\{\{[\w]+\}\}/g, "");

  return rendered;
}
